import React, { Component } from 'react'
import * as CONSTANTS from '../constants/constants'
import MenuCnt from '../containers/MenuCnt'
import LoginCnt from '../containers/LoginCnt'
// import PageEmbeddedCmp from './PageEmbeddedCmp'
import Cookies from 'js-cookie';
import { getTokenFromCookie } from '../services/loginServices';
// import {URL_LOGIN} from '../constants/config'

export default class AppCoreCmp extends Component {

  constructor(props) {
    super(props);

    var options = { expires: new Date(new Date().getTime() + 30 * 1000), domain: '.colonseguros.com.ar' }
    Cookies.set('portalProductores', 'donotredirect', options);
    this.lastLoadedToken = null;

    const handleLoginMessage = (event) => {
      //console.log("event 1", event)
      if (event && event.data && event.data.message === "login") {
        let incomingToken = event.data.token;
        if (typeof incomingToken === 'string') {
          incomingToken = incomingToken.replace(/^"|"$/g, '');
        }
        let tokenFound = incomingToken || getTokenFromCookie();
        if (tokenFound && this.lastLoadedToken !== tokenFound) {
          this.lastLoadedToken = tokenFound;
          props.getMenu(tokenFound);
          props.getIntermediario({ token: tokenFound });
        }
      }
      if (event && event.data && event.data.message === "menuPermissions") {
        //console.log("messages", event.data.value)
        try {
          localStorage.setItem("menuPermissions", event.data.value);
        } catch (e) { }
      }
    };

    this.handleMessage = handleLoginMessage;
    if (typeof window !== 'undefined') {
      window.addEventListener('message', handleLoginMessage);
      window.onmessage = handleLoginMessage;
      if (window.parent && window.parent !== window) {
        window.parent.onmessage = handleLoginMessage;
      }
    }

    this.state = {
      menu: undefined,
      status: CONSTANTS.NOT_LOGGED
    }
    props.getMenu()
    props.getIntermediario();
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined' && this.handleMessage) {
      window.removeEventListener('message', this.handleMessage);
    }
  }

  componentDidUpdate(prevProps) {
    this.ifStatusChange(prevProps);
    if (prevProps.loginStatus !== this.props.loginStatus && this.props.loginStatus === 'SUCCESS') {
      const token = this.props.loginResponse?.access_token || getTokenFromCookie();
      if (token && this.lastLoadedToken !== token) {
        this.lastLoadedToken = token;
        this.props.getMenu(token);
        this.props.getIntermediario({ token: token });
      }
    }
  }

  ifStatusChange(prevProps) {
    if (prevProps.menu !== this.props.menu) {
      this.setState({ menu: this.props.menu })
    }
    //console.log("app this.props: ",this.props)
  }

  onClickProps() {

  }

  getMenu() {
    this.props.getMenu()
  }

  render() {
    // let urlHome = URL_LOGIN
    let menu = null
    let token = getTokenFromCookie();

    if (!token) {
      let account = null;
      try {
        account = Cookies.getJSON("account");
      } catch (e) { }
      if (!account) {
        try {
          let raw = Cookies.get("account");
          if (raw) account = JSON.parse(decodeURIComponent(raw));
        } catch (e) {
          try {
            let raw = Cookies.get("account");
            if (raw) account = JSON.parse(decodeURI(raw));
          } catch (e2) { }
        }
      }
      if (account && typeof account === 'object') {
        token = account.token || account.access_token;
      }
    }

    if (!token && this.props.loginResponse && this.props.loginResponse.access_token) {
      token = this.props.loginResponse.access_token;
    }

    const currentMenu = (this.props.menu && this.props.menu.menu)
      ? this.props.menu
      : (this.state.menu && this.state.menu.menu ? this.state.menu : null);

    const hasValidMenu = currentMenu && Array.isArray(currentMenu.menu) && currentMenu.menu.length > 0;

    if (token && hasValidMenu) {
      menu = <MenuCnt />
    }
    else {
      // menu = <PageEmbeddedCmp url={urlHome} openMenu={false} showMenu={false}/>
      if (!token || (!hasValidMenu && this.props.menu && this.props.menu.error === "invalid_token"))
        menu = <LoginCnt />
    }

    return (
      <div>
        {menu}
      </div>
    );
  }
}